export default __webpack_public_path__ + "static/media/birthday.5f1dc61f.svg";